import { useState } from "react";
import { api } from "../../lib/api";
import { toast } from "sonner";

export function AdminLogin({ onLogin }) {
  const [creds, setCreds] = useState({ email: "", password: "" });
  const [signingIn, setSigningIn] = useState(false);

  const doLogin = async (e) => {
    e?.preventDefault?.();
    setSigningIn(true);
    try {
      const r = await api.post("/auth/login", { email: creds.email, password: creds.password });
      onLogin(r.data);
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Incorrect email or password");
    }
    setSigningIn(false);
  };

  return (
    <main data-testid="admin-login" className="px-6 md:px-12 lg:px-16 pt-16 pb-24 max-w-md">
      <div className="label-eyebrow mb-6">Admin</div>
      <h1 className="font-black tracking-tighter text-5xl md:text-6xl">Sign in.</h1>
      <p className="mt-6 text-[#6B7280]">Enter your email and password to access the panel.</p>
      <form onSubmit={doLogin} className="mt-8 space-y-4" data-testid="admin-login-form">
        <div>
          <label className="label-eyebrow block mb-2">Email</label>
          <input data-testid="admin-email" type="email" autoComplete="username" value={creds.email}
            onChange={e => setCreds({ ...creds, email: e.target.value })}
            className="w-full border border-[#E5E7EB] bg-white px-4 py-3 focus:outline-none focus:border-[#C79A3B]" />
        </div>
        <div>
          <label className="label-eyebrow block mb-2">Password</label>
          <input data-testid="admin-password" type="password" autoComplete="current-password" value={creds.password}
            onChange={e => setCreds({ ...creds, password: e.target.value })}
            className="w-full border border-[#E5E7EB] bg-white px-4 py-3 focus:outline-none focus:border-[#C79A3B]" />
        </div>
        <button data-testid="admin-login-submit" type="submit" disabled={signingIn} className="de-btn-primary mt-2">
          {signingIn ? "Signing in…" : "Sign in"}
        </button>
      </form>
    </main>
  );
}
